<template>
    <div class="etm-license-notice">
        <div class="etm-notice etm-notice-warning etm-license-notice-inner">
            <div v-html="licenseNoticeContent">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props : [
            'licenseNoticeContent',
        ],
    }
</script>